import GoogleAnalyticsContainer from './GoogleAnalyticsContainer';

export default GoogleAnalyticsContainer;
